<div class="loader-container">
	<app-loader
		[enableCircle]="true"
		[isActive]="isLoading.value"
		[width]="20"
	></app-loader>
	<h1 matDialogTitle>
		<div class="flex flex-row items-center justify-start">
			<div>{{ 'task.add' | translate }}</div>
			<div class="flex-auto"></div>
			<button
				mat-icon-button
				matDialogClose
				tabindex="-1"
			>
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</h1>
	<mat-dialog-content cdkTrapFocus>
		<form
			(submit)="$event.preventDefault()"
			[formGroup]="this.taskGroup"
			class="flex flex-col items-stretch justify-start py-2"
		>
			<div class="flex flex-col">
				<mat-form-field class="w-full">
					<mat-label>{{ 'Name' | translate }}</mat-label>
					<input
						cdkInitialFocus
						formControlName="name"
						matInput
						required
						type="text"
					>
					<mat-error *ngIf="getFormErrorByName('name') as error">
						{{ error.content | translate: error.args || {} }}
					</mat-error>
				</mat-form-field>
				<div class="flex flex-col space-y-0">
					<mat-form-field>
						<mat-label>{{ 'project.select' | translate }}</mat-label>
						<input
							[value]="
                taskGroup.value.project?.name
                  ? (taskGroup.value.project | defaultEntityTranslate: 'project' : 'project.none')
                  : null
              "
							disabled
							matInput
							type="text"
						>
						<mat-error *ngIf="!taskGroup.value.project"
							>{{ 'errors.required' | translate: { field: 'project.select' | translate } }}*</mat-error
						>
					</mat-form-field>
					<div
						*ngIf="(taskGroup.value.project | projectProxy)?.description as desc"
						class="rounded bg-neutral-800/5 px-2.5 py-3 text-sm dark:bg-black/20"
					>
						{{ desc }}
					</div>
				</div>
				<tg-duration-input-control
					[inputPlaceholder]="'timer.time.duration' | translate"
					formControlName="estimation"
				>
					<ng-template
						durationInputControl
						let-control="control"
						let-inputPlaceholder="inputPlaceholder"
					>
						<mat-form-field fxFill>
							<mat-label>{{ 'task.estimation' | translate }}</mat-label>
							<input
								[formControl]="control"
								autocomplete="off"
								matInput
								type="text"
							>
						</mat-form-field>
					</ng-template>
				</tg-duration-input-control>
				<div class="flex flex-col space-y-4">
					<div class="flex flex-col space-y-2">
						<div
							class="mat-hint text-sm"
							translate
						>
							task.assigned-users-or-groups
						</div>
						<tg-user-group-select-control
							[filterSearch]="filterProjectExclusive"
							formControlName="assigned"
						></tg-user-group-select-control>
					</div>
				</div>
				<div class="h-10"></div>
			</div>
		</form>
	</mat-dialog-content>
	<mat-dialog-actions class="mat-action-filled">
		<button
			(click)="createTask()"
			[disabled]="!(project$createPermission | async)"
			class="mat-action-filled"
			color="primary"
			mat-flat-button
		>
			{{ 'task.add' | translate }}
		</button>
	</mat-dialog-actions>
</div>
<ng-template #noSelectedUsers>
	<button
		(click)="openUserDialog()"
		mat-button
	>
		{{ 'workspace.groups.user-add' | translate }}
	</button>
</ng-template>
<ng-template
	#userTemplate
	let-user="user"
>
	<div
		[matTooltipTemplate]="userHoverCard"
		[matTooltipTemplateContext]="{ user: user }"
		class="h-10 w-10"
		matTooltip
	>
		<app-user-avatar
			[userId]="user.id"
			class="rounded-full"
			size="100%"
		></app-user-avatar>
	</div>
</ng-template>
<ng-template
	#userHoverCard
	let-user="user"
>
	<div class="-mx-1 flex flex-row items-center justify-start gap-2">
		<app-user-avatar
			[matTooltipTemplate]
			[userId]="user.id"
			class="rounded-xs"
			matTooltip
			size="40px"
		></app-user-avatar>
		<div class="mat-typography flex flex-col">
			<div>{{ user.name }}</div>
			<div class="mat-hint">{{ user.email | truncate: 42 }}</div>
		</div>
	</div>
</ng-template>
